// Presentation only. Server slot IDs and historical prizes are never reordered.
const ORDER=[0,5,1,6,2,7,3,8,4,9];
function wheelDisplaySlots(slots){
 if(slots.length===9)return [0,3,1,4,2,5,8,6,7].map(sourceIndex=>Object.assign({},slots[sourceIndex],{sourceIndex}));
 if(slots.length!==10)return slots.map((slot,sourceIndex)=>Object.assign({},slot,{sourceIndex}));
 return ORDER.map(sourceIndex=>Object.assign({},slots[sourceIndex],{sourceIndex}));
}
function wheelDisplayIndex(sourceIndex,slots){return wheelDisplaySlots(slots).findIndex(slot=>slot.sourceIndex===sourceIndex);}
module.exports={wheelDisplaySlots,wheelDisplayIndex};
